import { Component, OnInit } from '@angular/core';
import { SessionQuery } from '../../core/state-mangement/session/session.query';
import { BackendQuery } from '../../core/state-mangement/backend/backend.query';
import { BackendService } from '../../core/state-mangement/backend/backend.service';
import { TextKeys } from '../../core/i18n/text-keys';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss'],
})
export class DefaultHeaderComponent implements OnInit {
  loggedIn$ = this.sessionQuery.successful$;
  online$ = this.backendQuery.online$;
  servicePause$ = this.backendQuery.servicePause$;

  texts = TextKeys;

  constructor(
    private sessionQuery: SessionQuery,
    private backendQuery: BackendQuery,
    private backendService: BackendService
  ) {}

  ngOnInit() {}

  reloadClick() {
    this.backendService.checkBackendStatus();
  }
}
